import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api-client';

// QueryClient global. Defaults conservadores:
// - retry custom: nao retenta 401/403/404 (regra clara, sem flicker no UI)
// - staleTime 30s: evita refetch agressivo entre navegacoes
// - refetchOnWindowFocus off: backend nao guenta loop em multiplas abas
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (error instanceof ApiError) {
          if (error.status === 401 || error.status === 403 || error.status === 404) {
            return false;
          }
        }
        return failureCount < 2;
      },
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
